import { useCallback } from 'react';

import { usePetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';
import type { CallbackData } from '#src/app/pages/petitionDetails/shared/types';
import { useLocalStorageValueAsync } from '#src/app/shared/hooks/storage';

import { useGetFormData } from '../useGetFormData';
import { useGetMetaData } from '../useGetMetaData';
import { useGetUserData } from '../useGetUserData';

type Result = (data: CallbackData | null) => void;

// TODO: extract this and src/app/pages/membership/offer/shared/membershipAsk/hooks/useCreateMembership/utils/getConsentInputFromPendingSigInLocalStorage/index.ts
// to a shared hook folder to co-locate typings, etc
export function useSetLocalStoredPendingSignature(): Result {
	const getFormData = useGetFormData();
	const getUserData = useGetUserData();
	const getMetaData = useGetMetaData();

	const {
		data: { petition: details },
	} = usePetitionDetailsPageData();
	// TODO use usePendingSignature() shared hook
	const [, setPendingSignStr] = useLocalStorageValueAsync(`pending-signature-${details.id}`);

	return useCallback(
		(data) => {
			if (!data) {
				setPendingSignStr(null);
				return;
			}
			setPendingSignStr(
				JSON.stringify({
					formData: getFormData(data),
					userAccountData: getUserData(data),
					metaData: getMetaData(data),
				}),
			);
		},
		[setPendingSignStr, getFormData, getUserData, getMetaData],
	);
}
